
import Vue from 'vue'

const locales = {keys(){return []}}
global['____17C46E6____'] = true;
delete global['____17C46E6____'];
global.__uniConfig = {"globalStyle":{"navigationBarTextStyle":"black","navigationBarTitleText":"uni-app","navigationBarBackgroundColor":"#F8F8F8","backgroundColor":"#F8F8F8","pageOrientation":"auto","background":"#efeff4"}};
global.__uniConfig.compilerVersion = '4.66';
global.__uniConfig.darkmode = false;
global.__uniConfig.themeConfig = {};
global.__uniConfig.uniPlatform = 'h5';
global.__uniConfig.appId = '__UNI__17C46E6';
global.__uniConfig.appName = 'PLM';
global.__uniConfig.appVersion = '1.0.0';
global.__uniConfig.appVersionCode = '100';
global.__uniConfig.router = {"mode":"hash","base":"/"};
global.__uniConfig.publicPath = "/";
global.__uniConfig['async'] = {"loading":"AsyncLoading","error":"AsyncError","delay":200,"timeout":60000};
global.__uniConfig.debug = false;
global.__uniConfig.networkTimeout = {"request":60000,"connectSocket":60000,"uploadFile":60000,"downloadFile":60000};
global.__uniConfig.sdkConfigs = {"maps":{"qqmap":{"key":"JZ3BZ-CM56X-ZOB4X-Z2N2A-XSL2S-DZFD4"}}};
global.__uniConfig.qqMapKey = "JZ3BZ-CM56X-ZOB4X-Z2N2A-XSL2S-DZFD4";
global.__uniConfig.googleMapKey = undefined;
global.__uniConfig.aMapKey = undefined;
global.__uniConfig.aMapSecurityJsCode = undefined;
global.__uniConfig.aMapServiceHost = undefined;
global.__uniConfig.locale = "";
global.__uniConfig.fallbackLocale = undefined;
global.__uniConfig.locales = locales.keys().reduce((res,key)=>{const locale=key.replace(/\.\/(uni-app.)?(.*).json/,'$2');const messages = locales(key);Object.assign(res[locale]||(res[locale]={}),messages.common||messages);return res},{});
global.__uniConfig.nvue = {"flex-direction":"column"}
global.__uniConfig.__webpack_chunk_load__ = __webpack_chunk_load__
Vue.component('pages-home-home', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_yfg_pdm_app/pages/home/home"+'.vue')), 'pages-home-home'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-login-login', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_yfg_pdm_app/pages/login/login"+'.vue')), 'pages-login-login'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-pdm-templateTask-templateTask', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_yfg_pdm_app/pages/pdm/templateTask/templateTask"+'.vue')), 'pages-pdm-templateTask-templateTask'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-pdm-templateTask-templateDetail-templateDetail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_yfg_pdm_app/pages/pdm/templateTask/templateDetail/templateDetail"+'.vue')), 'pages-pdm-templateTask-templateDetail-templateDetail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-pdm-taskALlllocation-taskALlllocation', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_yfg_pdm_app/pages/pdm/taskALlllocation/taskALlllocation"+'.vue')), 'pages-pdm-taskALlllocation-taskALlllocation'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-pdm-fobTemplateTask-templateTask', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_yfg_pdm_app/pages/pdm/fobTemplateTask/templateTask"+'.vue')), 'pages-pdm-fobTemplateTask-templateTask'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-pdm-fobTaskAllocation-taskAllocation', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_yfg_pdm_app/pages/pdm/fobTaskAllocation/taskAllocation"+'.vue')), 'pages-pdm-fobTaskAllocation-taskAllocation'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-pdm-addProductionWarehousing-addProductionWarehousing', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_yfg_pdm_app/pages/pdm/addProductionWarehousing/addProductionWarehousing"+'.vue')), 'pages-pdm-addProductionWarehousing-addProductionWarehousing'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-pdm-warehousList-warehousList', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_yfg_pdm_app/pages/pdm/warehousList/warehousList"+'.vue')), 'pages-pdm-warehousList-warehousList'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-wms-purchaseOrder-purchaseOrder', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_yfg_pdm_app/pages/wms/purchaseOrder/purchaseOrder"+'.vue')), 'pages-wms-purchaseOrder-purchaseOrder'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-wms-purchaseOrder-purchaseDetail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_yfg_pdm_app/pages/wms/purchaseOrder/purchaseDetail"+'.vue')), 'pages-wms-purchaseOrder-purchaseDetail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
global.__uniRoutes=[
{
path: '/',
alias:'/pages/home/home',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isEntry:true,

          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"工作台","titleNView":false})
      },
      [
        createElement('pages-home-home', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:1,
  name:'pages-home-home',
  isNVue:false,maxWidth:0,
  pagePath:'pages/home/home',
isQuit:true,
isEntry:true,
  windowTop:0
}
},
{
path: '/pages/login/login',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"登录页","enablePullDownRefresh":false,"titleNView":false})
      },
      [
        createElement('pages-login-login', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-login-login',
  isNVue:false,maxWidth:0,
  pagePath:'pages/login/login',
  windowTop:0
}
},
{
path: '/pages/pdm/templateTask/templateTask',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"打版任务","enablePullDownRefresh":true,"titleNView":false})
      },
      [
        createElement('pages-pdm-templateTask-templateTask', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-pdm-templateTask-templateTask',
  isNVue:false,maxWidth:0,
  pagePath:'pages/pdm/templateTask/templateTask',
  windowTop:0
}
},
{
path: '/pages/pdm/templateTask/templateDetail/templateDetail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"详情","enablePullDownRefresh":false,"titleNView":false})
      },
      [
        createElement('pages-pdm-templateTask-templateDetail-templateDetail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-pdm-templateTask-templateDetail-templateDetail',
  isNVue:false,maxWidth:0,
  pagePath:'pages/pdm/templateTask/templateDetail/templateDetail',
  windowTop:0
}
},
{
path: '/pages/pdm/taskALlllocation/taskALlllocation',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"样衣任务","enablePullDownRefresh":true,"titleNView":false})
      },
      [
        createElement('pages-pdm-taskALlllocation-taskALlllocation', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-pdm-taskALlllocation-taskALlllocation',
  isNVue:false,maxWidth:0,
  pagePath:'pages/pdm/taskALlllocation/taskALlllocation',
  windowTop:0
}
},
{
path: '/pages/pdm/fobTemplateTask/templateTask',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"FOB打版任务","enablePullDownRefresh":true,"titleNView":false})
      },
      [
        createElement('pages-pdm-fobTemplateTask-templateTask', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-pdm-fobTemplateTask-templateTask',
  isNVue:false,maxWidth:0,
  pagePath:'pages/pdm/fobTemplateTask/templateTask',
  windowTop:0
}
},
{
path: '/pages/pdm/fobTaskAllocation/taskAllocation',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"FOB样衣任务","enablePullDownRefresh":true,"titleNView":false})
      },
      [
        createElement('pages-pdm-fobTaskAllocation-taskAllocation', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-pdm-fobTaskAllocation-taskAllocation',
  isNVue:false,maxWidth:0,
  pagePath:'pages/pdm/fobTaskAllocation/taskAllocation',
  windowTop:0
}
},
{
path: '/pages/pdm/addProductionWarehousing/addProductionWarehousing',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"入库扫描详情","enablePullDownRefresh":true,"titleNView":false})
      },
      [
        createElement('pages-pdm-addProductionWarehousing-addProductionWarehousing', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-pdm-addProductionWarehousing-addProductionWarehousing',
  isNVue:false,maxWidth:0,
  pagePath:'pages/pdm/addProductionWarehousing/addProductionWarehousing',
  windowTop:0
}
},
{
path: '/pages/pdm/warehousList/warehousList',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"预约入库记录","enablePullDownRefresh":true,"titleNView":false})
      },
      [
        createElement('pages-pdm-warehousList-warehousList', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-pdm-warehousList-warehousList',
  isNVue:false,maxWidth:0,
  pagePath:'pages/pdm/warehousList/warehousList',
  windowTop:0
}
},
{
path: '/pages/wms/purchaseOrder/purchaseOrder',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"采购单","enablePullDownRefresh":true,"titleNView":false})
      },
      [
        createElement('pages-wms-purchaseOrder-purchaseOrder', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-wms-purchaseOrder-purchaseOrder',
  isNVue:false,maxWidth:0,
  pagePath:'pages/wms/purchaseOrder/purchaseOrder',
  windowTop:0
}
},
{
path: '/pages/wms/purchaseOrder/purchaseDetail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"采购单详情","enablePullDownRefresh":true,"titleNView":false})
      },
      [
        createElement('pages-wms-purchaseOrder-purchaseDetail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-wms-purchaseOrder-purchaseDetail',
  isNVue:false,maxWidth:0,
  pagePath:'pages/wms/purchaseOrder/purchaseDetail',
  windowTop:0
}
},
{
path: '/choose-location',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props:{
          navigationStyle:'custom'
        }
      },
      [
        createElement('system-choose-location', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'choose-location',
  pagePath:'/choose-location'
}
}
    ,
{
path: '/open-location',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props:{
          navigationStyle:'custom'
        }
      },
      [
        createElement('system-open-location', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'open-location',
  pagePath:'/open-location'
}
}
    ]
global.UniApp && new global.UniApp();
